import {
  fetch
} from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'


/**
 * 添加
 * @param {Object} data
 */
export function saveCustomer(data) {
  return fetch({
    url: '/auth/customer/save',
    method: 'POST',
    data
  })
}

/**
 * 绑定电梯
 * @param {Object} data
 */
export function bindLift(data) {
  return fetch({
    url: '/auth/customer/permissionLift/bindLift',
    method: 'POST',
    data
  })
}



/**
 * 列表
 * @param {Object} data
 */
export function getPageList(data) {
  return fetch({
    url: '/auth/customer/pageList',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 删除
 */
export function deleteContract(data) {
  return fetch({
    url: '/auth/customer/delete',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 二维码
 */
export function getQRCode(customerId) {
  return fetch({
    url: '/auth/customer/createQrCode',
    method: 'GET',
    params: {
      customerId
    },
    // responseType: 'blob'
    headers: {
      responseType: 'arraybuffer'
    }
  })
}


/**
 * @param {Object} data
 * 二维码
 */
export function unBindWx(customerId) {
  return fetch({
    url: '/auth/customer/unBindWx',
    method: 'GET',
    params: {
      customerId
    },
  })
}




/**
 * @param {Object} data
 * 详情
 */
export function getContractDetail(params) {
  return fetch({
    url: '/financial/contract/maintain/detail',
    method: 'GET',
    params
  })
}


/**
 * 下载附件
 * @param {Object} data
 */
export function downloadAppendFile() {
  return formAxios({
    url: '/financial/contract/maintain/downloadAppendFile',
    method: 'GET'
  })
}


/**
 * @param {Object} data
 * 延期丢失
 */
export function extensionContract(data) {
  return fetch({
    url: '/financial/contract/maintain/extensionContract',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 结束
 */
export function finishContract(data) {
  return fetch({
    url: '/financial/contract/maintain/finishContract',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 回款列表
 */
export function getCollectionList(data) {
  return fetch({
    url: '/financial/collection/contract/list',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 回款添加编辑
 */
export function saveContractCollectionPlan(data) {
  return fetch({
    url: '/financial/collection/contract/collect',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 回款删除
 */
export function removeContractCollectionPlan(data) {
  return fetch({
    url: '/financial/collection/employee/remove',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 快速生成计划
 */
export function createContractCollectionPlan(data) {
  return fetch({
    url: '/financial/collection/plan/preview',
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/CustomerManagement/index.js